module.exports = __webpack_public_path__ + "static/bg-home1-5df89ababe809f4cbb17b6bba6704bf9.jpg";